import React, {createContext, useState, useEffect, ReactNode, useMemo} from 'react';
import {AllSettings} from "../models/settings.ts";
import {getAllSettings} from "../api/settingsApi.ts";
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

interface SettingsContextProps {
    settings: AllSettings | null;
    loading: boolean;
    error: string | null;
}

export const SettingsContext = createContext<SettingsContextProps>({
    settings: null,
    loading: false,
    error: null,
});

interface SettingsProviderProps {
    children: ReactNode;
}

export const SettingsProvider: React.FC<SettingsProviderProps> = ({children}) => {
    const [settings, setSettings] = useState<AllSettings | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);

    useEffect(() => {
        const fetchSettings = async () => {
            // Only fetch settings if user is authenticated
            if (!isAuthenticated) {
                setLoading(false);
                return;
            }

            try {
                console.log("Fetching settings...");
                const response = await getAllSettings();
                    console.log("Settings fetched:", response.data);
                    setSettings(response.data);
                }
             catch (err) {
                    console.error('Failed to fetch settings:', err);
                    setError('Failed to fetch settings');
                }
             finally {
                    setLoading(false);
                }
        };

        fetchSettings();
    }, [isAuthenticated]);

    // Memoize the context value to prevent unnecessary re-renders
    const contextValue = useMemo(() => ({
        settings,
        loading,
        error
    }), [settings, loading, error]);

    return (
        <SettingsContext.Provider value={contextValue}>
            {children}
        </SettingsContext.Provider>
    );
};
